import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService, LangChangeEvent, TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { svgIconList } from '@shared/svg-icon-list';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { CommonModule } from '@angular/common';
import { PlatformService } from '@core/services/platform.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-sidepanels',
  imports: [CommonModule, TranslateModule, SafeHtmlPipe],
  templateUrl: './sidepanels.component.html',
  styleUrls: ['./sidepanels.component.scss']
})
export class SidePanelsComponent implements OnInit {

  contactList$: any = [];

  svg: any = svgIconList;
  languageCode = environment.defaultLanguage;
  private langChangeSubscription: Subscription;

  constructor(
    private eventEmitterService: EventEmitterService,
    private router: Router,
    private translate: TranslateService,
    private platformService: PlatformService
  ) {
    if (this.platformService.isBrowser()) {
      this.languageCode = localStorage.getItem('language_code');
    }
   }

  ngOnInit() {
    if (this.platformService.isBrowser()) {
      this.eventEmitterService.updateContactUsEmitter.subscribe(() => {
      this.contactList$ = JSON.parse(sessionStorage.getItem('contact_us'));
    });
    }
    
    // Subscribe to language change events to add class for the 'Contact Us' <p> script tag
    this.langChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.languageCode = event.lang;
    });
  }

  onContact(link: string) {
    if (link !== undefined && link !== null) {
      if (link.includes('external')) {
        this.router.navigate([]).then(() => { window.open(link, '_blank'); });
      } else {
        window.open(link, "_blank");
      }
    }
  }

}
